import React, { useState, useEffect, useContext } from 'react';
import { Button, Chip, TextField } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';

const VolunteerPositions = () => {
	const { user } = useContext(AuthContext);
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);
	const [assignmentList, setAssignmentList] = useState('');
	const [showReject, setShowReject] = useState(false);
	const [posCode, setPosCode] = useState('');
	const [posDate, setPosDate] = useState('');
	const [posType, setPosType] = useState('');
	const [rejectReason, setRejectReason] = useState('');

	const columns = [
		{
			field: 'Assignment_date', headerName: 'Date', flex: 1, minWidth: 200,
			valueGetter: (params) => {
				return moment(params?.row?.Shift_Date).format('ddd Do MMMM YYYY');
			}
		},

		{
			field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 200,
			renderCell: (params) => {
				return `${(params?.row?.Shift_Code == '2') ? 'DAY' : (params?.row?.Shift_Code == '3') ? 'NIGHT' : "EVENING"} (${varFormatTime(timeFormat(params?.row?.Start_Time), user?.Time_Format)} - ${varFormatTime(timeFormat(params?.row?.End_Time), user?.Time_Format)})`;
			}
		},

		{
			field: 'Position', headerName: 'Position', flex: 1, minWidth: 200,
			valueGetter: (params) => {
				return (params?.row?.Position_Name)
			}
		},

		{
			field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 200,
			renderCell: (params) => {
				return (params?.row?.Assignment_Name)
			}
		},

		{
			field: 'action', headerName: 'Action', flex: 1, minWidth: 140,
			renderCell: (params) => {
				return params?.row?.cancelRequest == null ? (
				// 	<Button
				// 	variant="contained"
				// 	sx={{
				// 		backgroundColor: '#ff0000',
				// 		color: '#ffffff',
				// 		padding: '8px',
				// 		boxShadow: 'none',
				// 		'&:hover': {
				// 			backgroundColor: '#E62719',
				// 			boxShadow: 'none',
				// 		},
				// 	}}
				// >
				<ButtonTheme
					color="primary"
					className="rounded-2"
					onClick={() => {
						setShowReject(true);
						setPosCode(params?.row?.Shift_Code)
						setPosDate(params?.row?.Shift_Date)
						setPosType(params?.row?.Shift_Type)
					}}
				>
					Request Cancellation 
				</ButtonTheme>
				) : params?.row?.cancelRequest?.Status === 'pending' ? (
						<Chip style={{ width: '100px' }}
						color={'warning'}
						label={"Pending"} />
				) : params?.row?.cancelRequest?.Status === 'rejected' ? (
					<Chip style={{ width: '100px' }}
						color={'primary'}
						label={"Rejected"} />
				)  : 
					<Chip style={{ width: '100px' }}
						color={'success'}
						label={"Accepted"} />;
			},
		}
	]

	const getAssignmentList = () => {
		ApiService.get('/myPositionAssignments')
			.then((data) => {
				const rowsWithIds = data?.data?.position_assignments?.map((item, index) => ({
					...item,
					id: index + 1
				})) || [];
				setAssignmentList(rowsWithIds);
				// setLoading(false);
			})
			.catch((e) => {
				// setLoading(false);
			});
	};

	const rejectShift = () => {
		ApiService.post("/requestPositionAssignmentFillCancel", {
			"Shift_Code": parseInt(posCode),
			"Shift_Date": posDate ? moment(posDate).format('YYYY-MM-DD') : null,
			"Shift_Type": posType,
			"Reason": rejectReason
		})
			.then((data) => {
				setShowReject(false)
				setRejectReason('')
				toast.success(data?.message)
				getAssignmentList(false)
			})
			.catch((error) => {
				toast.error(error?.data?.message)
			});
	}

	useEffect(() => {
		getAssignmentList()
	}, [])

	return (
		<>
			{(!assignmentList || assignmentList.length == 0) ?
				<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
					<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
					<span className='mt-4' style={{ color: '#555555' }}>
						No Positions Found
					</span>
				</div>
				:
				<>
					<div className='mt-4'>
						<MyTable
							rows={assignmentList}
							columns={columns}
							checkboxSelection={false}
							hideFooter={true}
						/>
					</div>
				</>
			}

			<Modal show={showReject} size="md"
				onHide={() => { setShowReject(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Request Cancellation</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
						<div className="p-0" style={{ color: '#555555', marginBottom: '12px' }}>
							Enter the reason for cancellation request.
						</div>
						<Col md={12} className="p-0">
							<TextField
								className='mt-1 w-100'
								multiline
								color='secondary'
								variant="outlined"
								value={rejectReason}
								placeholder="Enter Reason"
								sx={{
									"& .MuiInputBase-input": {
										minHeight: '150px',
										maxHeight: '150px',
										overflow: 'scroll !important',
										scrollbarWidth: 'none'
									}
								}}
								onChange={(e) => setRejectReason(e.target.value)}
							/>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowReject(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => rejectShift()}>
								Submit
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default VolunteerPositions;
